import TagManager from "@sooro-io/react-gtm-module";
import { readPersistedAirlineRouterState } from "../transport/airlineTransportContext";
import { buildMarketplaceContextPayload } from "./buildMarketplaceContextPayload";
import { getMarketplaceSessionPayloadFields, initMarketplaceSession } from "./marketplaceSession";
import { MarketplaceContextPayload, PushMarketplaceContextInput } from "./types";

export const pushMarketplaceContext = ({
  cookieAccepted,
  persistedAirlineState,
  session,
  ...payloadInput
}: PushMarketplaceContextInput): MarketplaceContextPayload | null => {
  if (cookieAccepted !== true) {
    return null;
  }

  initMarketplaceSession(payloadInput.platformType);

  const resolvedPersistedAirlineState = (() => {
    if (persistedAirlineState !== undefined) {
      return persistedAirlineState;
    }

    const raw = readPersistedAirlineRouterState();
    if (!raw) {
      return null;
    }

    if (typeof raw === "object") {
      return raw as any;
    }

    return null;
  })();

  const sessionFields = session ?? getMarketplaceSessionPayloadFields();

  const payload = buildMarketplaceContextPayload({
    ...payloadInput,
    persistedAirlineState: resolvedPersistedAirlineState,
    session: sessionFields
  });

  TagManager.dataLayer({
    dataLayer: payload
  });

  return payload;
};
